import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { getLocalBankAccountNumberFromIBAN } from "Utils/AccountUtils";

export const formatConnectedAccount = ({
  iban,
  ownersNames,
  productName,
  currency,
}: BankAccountListItem) => {
  const localBankAccountNumber = getLocalBankAccountNumberFromIBAN(iban);
  const owners = ownersNames.join(", ");
  const currencySuffix = currency ? ` - ${currency}` : "";
  const ownersPrefix = owners ? `${owners} - ` : "";

  return `${ownersPrefix}${productName} (${localBankAccountNumber}${currencySuffix})`;
};
